import React, { useContext, useState } from 'react';
import './TopMenuBar.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cursorDefault from '../../assets/cursors/cursor-default.png';
import cursorPointer from '../../assets/cursors/cursor-pointer.png';
import {
  faArrowLeft,
  faArrowRight,
  faTrash,
  faCopy,
  faPaste,
  faArrowUp,
  faArrowDown,
  faEdit,
  faLock,
  faUnlock,
  faMagicWandSparkles,
  faUserShield,
  faHome,
  faQuestionCircle,
} from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../../context/UserContext';
import HomeModal from '../HomeModal/HomeModal';

const TopMenuBar = ({
  undo,
  redo,
  deleteSelectedShapes,
  selectedShapeIds,
  copySelectedShapes,
  pasteCopiedShapes,
  canPaste,
  bringForward,
  sendBack,
  isEditMode,
  toggleEditMode,
  areAllSelectedLocked,
  lockSelectedShapes,
  copyToAllPages,
  onOpenToolsTour,
}) => {
  const { currentUser } = useContext(UserContext);
  const navigate = useNavigate();
  const [isHomeModalOpen, setHomeModalOpen] = useState(false);

  const menuCursorDefault = `url(${cursorDefault}) 2 2, default`;
  const menuCursorPointer = `url(${cursorPointer}) 6 2, pointer`;

  const handleHomeClick = () => setHomeModalOpen(true);
  const handleHomeYes = () => {
    setHomeModalOpen(false);
    navigate('/splash');
  };
  const handleHomeNo = () => setHomeModalOpen(false);

  return (
    <>
      <div
        className="top-menu"
        style={{ cursor: menuCursorDefault }}
        data-tour="editor-top-menu"
      >
        {Number(currentUser?.isAdmin) === 1 && (
          <button
            onClick={() => navigate('/admin')}
            title="Admin"
            style={{ cursor: menuCursorPointer }}
          >
            <FontAwesomeIcon icon={faUserShield} />
          </button>
        )}

         <button
          onClick={handleHomeClick}
          title="Home"
          style={{
            cursor: menuCursorPointer,
            marginLeft: 'auto',
          }}
        >
          <FontAwesomeIcon icon={faHome} />
        </button>

        <button
          type="button"
          onClick={onOpenToolsTour}
          title="Learn the Tools"
          aria-label="Learn the Tools"
          style={{ cursor: menuCursorPointer }}
          data-tour="learn-tools-button"
        >
          <FontAwesomeIcon icon={faQuestionCircle} />
        </button>

        <button
          onClick={undo}
          title="Undo (Ctrl+Z)"
          style={{ cursor: menuCursorPointer }}
        >
          <FontAwesomeIcon icon={faArrowLeft} />
        </button>

        <button
          onClick={redo}
          title="Redo (Ctrl+Shift+Z)"
          style={{ cursor: menuCursorPointer }}
        >
          <FontAwesomeIcon icon={faArrowRight} />
        </button>

        <button
          onClick={deleteSelectedShapes}
          disabled={selectedShapeIds.length === 0}
          title="Delete (Del)"
          style={{
            cursor:
              selectedShapeIds.length === 0
                ? menuCursorDefault
                : menuCursorPointer,
          }}
        >
          <FontAwesomeIcon icon={faTrash} />
        </button>

        <button
          onClick={copySelectedShapes}
          disabled={selectedShapeIds.length === 0}
          title="Copy (Ctrl+C)"
          style={{
            cursor:
              selectedShapeIds.length === 0
                ? menuCursorDefault
                : menuCursorPointer,
          }}
        >
          <FontAwesomeIcon icon={faCopy} />
        </button>

        <button
          onClick={() => {
            const fakeEvent = {
              preventDefault: () => {},
              target: { tagName: '', isContentEditable: false },
            };
            window.dispatchEvent(new ClipboardEvent('paste'));
          }}
          title="Paste (Ctrl+V)"
          style={{ cursor: menuCursorPointer }}
        >
          <FontAwesomeIcon icon={faPaste} />
        </button>

        <button
          onClick={bringForward}
          disabled={selectedShapeIds.length === 0}
          title="Bring Forward (Alt+Up Arrow)"
          style={{
            cursor:
              selectedShapeIds.length === 0
                ? menuCursorDefault
                : menuCursorPointer,
          }}
        >
          <FontAwesomeIcon icon={faArrowUp} />
        </button>

        <button
          onClick={sendBack}
          disabled={selectedShapeIds.length === 0}
          title="Send Back (Alt+Down Arrow)"
          style={{
            cursor:
              selectedShapeIds.length === 0
                ? menuCursorDefault
                : menuCursorPointer,
          }}
        >
          <FontAwesomeIcon icon={faArrowDown} />
        </button>

        <button
          onClick={copyToAllPages}
          disabled={selectedShapeIds.length === 0}
          title="Copy to All Pages"
          className="copy-all-pages-button"
          style={{
            cursor:
              selectedShapeIds.length === 0
                ? menuCursorDefault
                : menuCursorPointer,
          }}
        >
          <FontAwesomeIcon icon={faMagicWandSparkles} />
        </button>

        <button
          onClick={lockSelectedShapes}
          disabled={!isEditMode || selectedShapeIds.length === 0}
          title="Lock/Unlock Selected Shapes"
          className={areAllSelectedLocked ? 'locked' : ''}
          style={{
            cursor:
              !isEditMode || selectedShapeIds.length === 0
                ? menuCursorDefault
                : menuCursorPointer,
          }}
        >
          <FontAwesomeIcon icon={areAllSelectedLocked ? faLock : faUnlock} />
        </button>

        <button
          onClick={toggleEditMode}
          title="Edit Mode"
          className={isEditMode ? 'edit-mode-active' : ''}
          style={{ cursor: menuCursorPointer }}
        >
          <FontAwesomeIcon icon={faEdit} />
        </button>
       
      </div>

      {isHomeModalOpen && (
        <HomeModal onYes={handleHomeYes} onNo={handleHomeNo} />
      )}
    </>
  );
};

export default TopMenuBar;